
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"15","viewBox":"0 0 11 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.52 5.693a.094.094 0 00-.116-.03.099.099 0 00-.064.106c.008.084.013.17.014.255.003.352-.138.697-.388.946a1.275 1.275 0 01-.922.377c-.476-.006-.87-.253-1.14-.716-.223-.383-.125-.876-.021-1.399.06-.305.124-.622.124-.923C7.007 1.966 5.43.614 4.492.017A.1.1 0 004.438 0a.106.106 0 00-.058.019.094.094 0 00-.042.1c.359 1.905-.712 3.052-1.845 4.266C1.324 5.635 0 7.054 0 9.61A5.395 5.395 0 005.389 15c2.447 0 4.604-1.706 5.246-4.148.438-1.665-.021-3.787-1.116-5.159zM5.522 13.85a2.683 2.683 0 01-1.992-.75 2.724 2.724 0 01-.841-1.958c0-1.375.526-2.384 1.94-3.725a.096.096 0 01.114-.018c.023.012.062.04.057.1-.051.589-.05 1.077.002 1.452.134.958.835 1.601 1.745 1.601.446 0 .87-.168 1.196-.472a.107.107 0 01.096-.028c.021.005.05.018.065.054.135.326.204.672.205 1.028.004 1.433-1.156 2.652-2.587 2.716z"}})])
          )
        }
      }
    